/* On-Brand Golf — small UX layer
 * Owns: scroll reveals, sticky add-to-cart visibility, free-shipping
 * progress text. Vanilla JS, no deps. Defer-loaded so it never blocks
 * paint.
 */
(function () {
  'use strict';

  // ---- reveal on scroll ----
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    document.querySelectorAll('.ob-reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.ob-reveal').forEach((el) => el.classList.add('is-in'));
  }

  // ---- hero auto-crossfade gallery ----
  // Cycles .ob-hero__cf-img frames every 5s. Frozen for reduced-motion.
  var cfWrap = document.querySelector('[data-ob-crossfade]');
  if (cfWrap) {
    var cfImgs = cfWrap.querySelectorAll('.ob-hero__cf-img');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (cfImgs.length > 1 && !reduce) {
      var cfIdx = 0;
      setInterval(function () {
        cfImgs[cfIdx].classList.remove('is-active');
        cfIdx = (cfIdx + 1) % cfImgs.length;
        cfImgs[cfIdx].classList.add('is-active');
      }, 5000);
    }
  }

  // ---- sticky add-to-cart on product page ----
  const sticky = document.querySelector('[data-ob-sticky-atc]');
  const trigger = document.querySelector('[data-ob-sticky-trigger]');
  if (sticky && trigger && 'IntersectionObserver' in window) {
    const stickyIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          // when the main ATC is OUT of view, show sticky bar
          sticky.classList.toggle('is-visible', !e.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    stickyIO.observe(trigger);

    const stickyBtn = sticky.querySelector('[data-ob-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const realBtn = trigger.querySelector('button[name="add"], .product-form__submit');
        if (realBtn) realBtn.click();
        else trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  // ---- A/B test click tracking ----
  // Any element with data-ab-click="<testId>:<variant>" pushes a
  // dataLayer event when clicked, so GA4 / Meta can attribute the
  // downstream conversion to the variant the visitor saw.
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ab-click]');
    if (!el) return;
    var parts = (el.dataset.abClick || '').split(':');
    if (parts.length !== 2) return;
    (window.dataLayer = window.dataLayer || []).push({
      event: 'ab_click',
      ab_test_id: parts[0],
      ab_variant: parts[1],
      ab_click_text: (el.textContent || '').trim().slice(0, 80),
      ab_click_url: el.href || ''
    });
  });

  // ---- free-shipping progress bar (cart) ----
  // Pulls a threshold from data-ob-ship-threshold (in cents) on the bar
  // and updates the message based on cart total injected by Shopify.
  const shipBar = document.querySelector('[data-ob-ship-bar]');
  if (shipBar) {
    const threshold = parseInt(shipBar.dataset.obShipThreshold || '7500', 10);
    const fmt = (cents) =>
      (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    const subtotalEl = document.querySelector('[data-cart-subtotal-cents]');
    const subtotal = subtotalEl ? parseInt(subtotalEl.dataset.cartSubtotalCents, 10) : 0;
    if (subtotal >= threshold) {
      shipBar.innerHTML = '🎉 You unlocked <strong>FREE shipping</strong>. Boy, are you on-brand.';
    } else if (subtotal > 0) {
      shipBar.innerHTML =
        'You’re <strong>' + fmt(threshold - subtotal) + '</strong> away from free shipping. Be cool, add another sticker.';
    }
  }

  // ---- cart-drawer upsell quick-add ----
  // [data-ob-upsell-add="<variantId>"] adds that variant via /cart/add.js,
  // then re-renders the cart drawer + cart bubble in place (no page reload).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ob-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-ob-upsell-add');
    if (!variantId) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sections = data && data.sections;
        if (sections) {
          if (sections['cart-drawer']) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var fresh = parsed.querySelector('#CartDrawer');
            var live = document.querySelector('#CartDrawer');
            if (fresh && live) live.innerHTML = fresh.innerHTML;
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              drawer.classList.remove('is-empty');
              if (typeof drawer.open === 'function') drawer.open();
            }
          }
          if (sections['cart-icon-bubble']) {
            var bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
          }
        }
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'ob_cart_upsell_add', variant_id: variantId });
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
